module.exports = __webpack_public_path__ + "assets/img/1_img8.84969366.png";